module.exports = __webpack_public_path__ + "img/c07_unitbowman_Normal_ua.19fb0920.webp";